import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { detectMob, loadQueryString, numberWithCommas, toMillions, makeGET, makePOST, returnNumber, makeGETCUSTOM, extraerNumeros } from "../../helpers/makeRequest";
import { conf } from '../../config/config'
import 'react-phone-number-input/style.css'
import moment from 'moment';
import $ from 'jquery'
import Spinner from 'react-bootstrap/Spinner';
import Select from "react-select";
import { createFilter } from "react-select";
import { Bar, Pie } from 'react-chartjs-2';
import 'chart.js/auto'
import seccion from '../../imgs/seccion_amarilla.png'

$.DataTable = require('datatables.net')
require("datatables.net-responsive");

export const SeccionScreen = () => {
  const user = useSelector((state) => state.auth);
  useEffect(() => {
    var x = new Date()

    var d = new Date(x.getFullYear(), x.getMonth() - 6, 1)
    x.setDate(0)
    var d1 = x
    let strDate = document.getElementById("strDate"), endDate = document.getElementById("endDate")
    strDate.setAttribute("value", "2025-02-19")
    strDate.setAttribute("max", moment(d1).format("YYYY-MM-DD"))
    endDate.setAttribute("value", moment(d1).format("YYYY-MM-DD"))
    endDate.setAttribute("min", moment(d).format("YYYY-MM-DD"))

    getDatos();
  }, []);

  const [datos, setDatos] = useState([]);
  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState({ label: "TODOS", value: "TODOS" });
  const [dataSesiones, setDataSesiones] = useState(undefined);
  const [dataFuentes, setDataFuentes] = useState({
    labels: ["Usuarios viejos", "Usuarios nuevos"],
    datasets: [{
      backgroundColor: ["#58ac3f", "#0097a7"],
      data: [2, 1]
    }]
  });

  const [dataFuentes1, setDataFuentes1] = useState(undefined);

  const [dataDevices, setDataDevices] = useState(undefined);

  const [searches, setSearches] = useState([])
  let options = {
    legend: { display: false },
    elements: {
      line: {
        tension: 0
      }
    },
    animation: false,
    scales: {
      y: {
        display: true,
        ticks: {
          beginAtZero: true
        }
      }
    },
    maintainAspectRatio: false
  }

  let optionsFuentes = {
    animation: false,
  }

  const [searchTable, setSearchTable] = useState(undefined)
  const [mediumTable, setMediumTable] = useState(undefined)

  const replace = (str, rep) => {
    return (str || "")?.replace(/-/g, " ")
  }

  useEffect(() => {
    if (search != "") {
      getDatos()
    }
  }, [search])

  const getDatos = async () => {

    document.getElementById("loading").classList.remove("d-none")
    let page = "", hostname = "", searchTmp = ((search != "" && search != "TODOS") ? search : "")
    const isMobile = detectMob()
    document.getElementById("loading").classList.remove("d-none")
    const params = loadQueryString();

    if (params.search) {
      searchTmp = params.search
      document.getElementById("hosts").style.display = "none"
    }

    const sampleUrl = "files_protected/sampleadnplus.json"
    const url = "report/bqPro?" + "dateStr="
      + document.getElementById("strDate").value + "&dateEnd=" + document.getElementById("endDate").value
      + (searchTmp != "" ? "&search=" + searchTmp : "")

    let strDate = document.getElementById("strDate"), endDate = document.getElementById("endDate")
    strDate.setAttribute("max", endDate.value)
    endDate.setAttribute("min", strDate.value)

    let secs, formatted
    makeGET(params.test ? sampleUrl : url).then(({ data }) => {
      console.log(data)
      document.getElementById("loading").classList.add("d-none")
      secs = parseInt(data.tiempoTotal + "")
      formatted = moment.utc(secs * 1000).format('HH:mm:ss');
      /*const table = $(`#table1`).DataTable(
        {
          searching: false, info: false, "dom": 'rtip',
          order: [[1, 'desc']],
          "responsive": true
        }
      )*/

      $("#usuarios").text(returnNumber(data.usuariosTotal))
      $("#sesiones").text(returnNumber(data.sesionesTotal))
      $("#usuarios_new").text(returnNumber(data.newUsers))

      $("#vistas").text(returnNumber(data.pageviewsTotal || 0))
      $("#duracion").text(formatted)

      data.months.sort((a, b) => (new Date(a.month) > new Date(b.month)) ? 1 : ((new Date(b.month) > new Date(a.month)) ? -1 : 0))

      const monthsParsed = data.months.map(v => v.monthParsed)
      const monthsSesiones = data.months.map(v => v.sesiones)
      const monthsUsuarios = data.months.map(v => v.usuarios)

      /*if (isMobile) {
        document.getElementById("sesionesBar1").style.height = (document.getElementById("sesionesBar1").offsetWidth - 100) + "px"
      }
      if (sesionesChart1) {
        sesionesChart1.destroy()
      }*/
      setDataSesiones({
        labels: monthsParsed,
        datasets: [{
          label: "Usuarios",
          type: "line",
          borderColor: "rgb(251, 188, 4)",
          backgroundColor: "white",
          data: monthsUsuarios,
          pointBorderWidth: 2,
          fill: false,
          tension: 0.2
        },
        {
          label: "Sesiones",
          type: "line",
          borderColor: "rgb(79, 79, 79)",
          backgroundColor: "white",
          data: monthsSesiones,
          pointBorderWidth: 2,
          tension: 0.2
        }
        ]
      })

      const searches_t = [...data.searches.map(v => {
        return {
          label: v, value: v
        }
      })]
      if (searches_t.length < 10000) {
        setSearches([{ label: "TODOS", value: "TODOS" }, ...searches_t])
      } else {
        setSearches([{ label: "TODOS", value: "TODOS" },])
      }


      if (searchTable) {
        searchTable.clear()
        searchTable.destroy()
      }

      data.acciones = data.acciones.map(v => {
        return {
          ...v,
          icon: icons[v.event_name]
        }
      })
      /*setSearchTable($(`#search`).DataTable(
        {
          searching: false, info: false, "dom": 'rtip',
          order: [[1, 'desc']],
          "responsive": true,
          data: data.acciones,
          columns: [
            { "data": "event_name" },
            { "data": "sesiones" },
          ]
        }
      ))*/
      setDateChanged(false)

      if (mediumTable) {
        mediumTable.clear()
        mediumTable.destroy()
      }
      /*setMediumTable($(`#mediums`).DataTable(
        {
          searching: false, info: false, "dom": 'rtip',
          order: [[1, 'desc']],
          "responsive": true,
          data: data.mediums,
          columns: [
            { "data": "medium" },
            { "data": "sesiones" },
          ]
        }
      ))*/

      let pieData = returnPieData(data.cities, "city", "sesiones")

      setDataFuentes1({
        labels: pieData.xValues,
        datasets: [{
          backgroundColor: ["#292b2c", "#56606b", "#ac1e75", "#58ac3f", "#0097a7"],
          data: pieData.yValues
        }]
      })

      pieData = returnPieData(data.devices, "deviceCategory", "sesiones")

      setDataDevices({
        labels: pieData.xValues,
        datasets: [{
          backgroundColor: ["#0097a7", "#58ac3f", "#ac1e75", "#56606b", "#292b2c"],
          data: pieData.yValues
        }]
      })


      setDatos({ ...data })
      /*strDate.setAttribute("min", data.min_date)
      endDate.setAttribute("max", data.max_date)*/
      //if (new Date(strDate.value) < new Date(data.min_date)) strDate.value = data.min_date
      //if (new Date(endDate.value) > new Date(data.max_date)) endDate.value = data.max_date
    }).catch((e) => {
      console.log(e)
      document.getElementById("loading").classList.add("d-none")
    })
  };
  const icons = {
    "Apariciones en listado": "fa fa-list-alt pr-2",
    'Ventana de información': "fa fa-address-card pr-2",
    'LLamadas': "fa fa-phone pr-2",
    'Clic a Whatsapp': "fa fa-whatsapp pr-2",
    'Clic sitio web': "fa fa-window-maximize pr-2",
    'Clic a email': "fa fa-envelope-o pr-2",
    'Aparición de anuncio': "fa fa-bullhorn pr-2",
    "mobile": "fa fa-mobile pr-2",
    "desktop": "fa fa-desktop pr-2",
    "smart tv": "fa fa-television pr-2",
    "tablet": "fa fa-tablet pr-2",
  }
  const returnPieData = (arr, x, y) => {
    let xValues = arr.slice(0, 4).map(v => v[x])
    let yValues = arr.slice(0, 4).map(v => v[y])
    if (arr.length > 4) {
      xValues = [...xValues, "Otros"]
      yValues = [...yValues.slice(0, 4), yValues.slice((yValues.length - (yValues.length - 4)), yValues.length).reduce((partialSum, a) => partialSum + a, 0)]
    }

    let tempArr = xValues.map((v, i) => {
      return {
        label: v,
        data: yValues[i] || 0
      }
    })

    tempArr.sort((a, b) => (a.data > b.data) ? 1 : ((b.data > a.data) ? -1 : 0))
    xValues = tempArr.map(v => v.label)
    yValues = tempArr.map(v => v.data)

    return { xValues, yValues }
  }

  const [showOptions, setShowOptions] = useState(false);
  const handleInputChange = useCallback((typedOption) => {
    if (typedOption.length > 2) {
      setShowOptions(true);

      if (searches.length == 0) {
        makeGETCUSTOM("https://sa-api.amarilio.net/", "searchBc?term=" + typedOption).then(v => {
          setSearches([{ label: "TODOS", value: "TODOS" }, ...v.data.map(v => { return { label: v, value: extraerNumeros(v) } })])
        }).catch(e => console.log(e))
      }
    }
    else {
      setShowOptions(false);
    }
  }, []);

  const [dateChanged, setDateChanged] = useState(false)
  return (
    <div className="">
      <div className="loading d-none text-center" id="loading">
        <div className="d-flex justify-content-center">
          <p className="m-0"><Spinner animation="border" role="status" variant="dark"></Spinner></p>
        </div>
        <div className="d-flex justify-content-center">
          <p style={{ color: "black", zIndex: 10001 }}>Cargando</p>
        </div>
      </div>
      <div id="firstRow" className="row p-3">
        <div className="col-12 col-md-4 pb-3 pt-3 pl-3 text-center">
          <img width="60%" src={seccion} />
        </div>
        <div className="col-12 col-md-4 pt-3">
          <Select
            options={(showOptions || searches.length < 1000) ? searches : []}
            autoFocus={false}
            className=""
            id="hosts"
            value={searchData}
            style={{ width: "100%", paddingTop: "1rem!important" }}
            isSearchable={true}
            noOptionsMessage={({ inputValue }) => "Escribe 2 o más letras para filtrar"}
            onInputChange={handleInputChange}
            filterOption={createFilter({ ignoreAccents: false })}
            onChange={(e) => {
              setSearch(e.value)
              setSearchData(e)
            }}
          />
        </div>
        <div className="col-12 col-md-4">
          <div className="row pt-0 pt-md-3 p-3">
            <div className="input-group">
              <input type="date" onChange={() => {
                let strDate = document.getElementById("strDate"), endDate = document.getElementById("endDate")
                strDate.setAttribute("max", endDate.value)
                endDate.setAttribute("min", strDate.value)
                setDateChanged(true)
              }} id="strDate" className="form-control" />
              <input type="date" onChange={() => {
                let strDate = document.getElementById("strDate"), endDate = document.getElementById("endDate")
                strDate.setAttribute("max", endDate.value)
                endDate.setAttribute("min", strDate.value)
                setDateChanged(true)
              }} id="endDate" className="form-control" />
              <button disabled={!dateChanged} onClick={getDatos} className="btn btn-primary"><i className="fa fa-search"></i></button>
            </div>
          </div>
        </div>
        <div className="col-md col-6 text-center mb-2">
          <p className="card-title font-weight-bold">Usuarios</p>
          <h5 className="card-text" id="usuarios">-</h5>
        </div>
        <div className="col-md col-6 text-center mb-2">
          <p className="card-title font-weight-bold">Usuarios nuevos</p>
          <h5 className="card-text" id="usuarios_new">-</h5>
        </div>
        <div className="col-md col-6 text-center mb-2">
          <p className="card-title font-weight-bold">Sesiones</p>
          <h5 className="card-text" id="sesiones">-</h5>
        </div>
        <div className="col-md col-6 text-center mb-2">
          <p className="card-title font-weight-bold">Vistas de pag.</p>
          <h5 className="card-text" id="vistas">-</h5>
        </div>
        <div className="col-md col-12 text-center mb-2">
          <p className="card-title font-weight-bold">Duración media</p>
          <h5 className="card-text" id="duracion">-</h5>
        </div>
        <div className="col-12 mt-3 p-3">
          {dataSesiones &&
            <Bar options={options} data={dataSesiones} style={{ height: "250px" }} />
          }
        </div>
        <div className="col-md-6 col-12 p-0 pl-2 pr-2 mb-3">
          <div className="card w-100">
            <div className="card-body text-center">
              <h5 className="card-title font-weight-bold">Dispositivos desde donde te visitan</h5>
            </div>
            <div className="row pl-3 pr-3">
              {datos?.devices &&
                <>
                  {datos?.devices?.map((v, i) => (
                    <>
                      <div className="col-1 border-bottom pb-1 pt-1 text-center">
                        <i className={icons[v.deviceCategory]}></i>
                      </div>
                      <div className="col-5 border-bottom pb-1 pt-1" style={{ textAlign: "left" }}>
                        <h6>{v.deviceCategory}</h6>
                      </div>
                      <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "center" }}>
                        <h6>{Number((v.sesiones / datos?.sesionesTotal) * 100).toFixed(2)} %</h6>
                      </div>
                    </>
                  ))}
                </>
              }
            </div>
          </div>
          {/* {dataDevices &&
            <Pie options={optionsFuentes} data={dataDevices} />
          } */}
        </div>
        <div className="col-12 col-md-6 p-0 pl-2 pr-2 mb-3">
          <div className="card w-100">
            <div className="card-body text-center">
              <h5 className="card-title font-weight-bold">Actividades que realizaron</h5>
            </div>
            <div className="row pl-3 pr-3">
              {datos?.acciones &&
                <>
                  {datos?.acciones?.map((v, i) => (
                    <>
                      <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "left" }}>
                        <i className={v.icon}></i>{v.event_name}
                      </div>
                      <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "center" }}>
                        <h6>{numberWithCommas(v.sesiones)}</h6>
                      </div>
                    </>
                  ))}
                </>
              }
            </div>
          </div>
          {/* <table id="search" className="d-none" style={{ width: "100%" }}>
            <thead style={{ backgroundColor: "#ac1e75", color: "white" }}>
              <tr id="searchHeader">
                <th>Acción</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody id="searchBody"></tbody>
          </table> */}
        </div>
        <div className="col-12 col-md-6 p-0 pl-2 pr-2 mb-3">
          <div className="card w-100">
            <div className="card-body text-center">
              <h5 className="card-title font-weight-bold">Medios desde donde te visitaron</h5>
            </div>
            <div className="row pl-3 pr-3">
              {datos?.mediums &&
                <>
                  {datos?.mediums?.slice(0, 5).map((v, i) => (
                    <>
                      <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "left" }}>
                        {v.medium}
                      </div>
                      <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "center" }}>
                        <h6>{numberWithCommas(v.sesiones)}</h6>
                      </div>
                    </>
                  ))}
                </>
              }
            </div>
          </div>
          {/* <table id="mediums" className="display" style={{ width: "100%" }}>
            <thead style={{ backgroundColor: "#ac1e75", color: "white" }}>
              <tr id="mediumsHeader">
                <th>Medio</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody id="mediumsBody"></tbody>
          </table> */}
        </div>
        <div className="col-md-6 col-12 p-0 pl-2 pr-2 mb-3">
          <div className="card w-100">
            <div className="card-body text-center">
              <h5 className="card-title font-weight-bold">Ciudades con más visitas</h5>
            </div>
            <div className="row pl-3 pr-3">
              {datos?.cities &&
                <>
                  {datos?.cities?.slice(0, 5).map((v, i) => (
                    <>
                      <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "left" }}>
                        {v.city}
                      </div>
                      <div className="col-6 border-bottom pb-1 pt-1" style={{ textAlign: "center" }}>
                        <h6>{Number((v.sesiones / datos?.sesionesTotal) * 100).toFixed(2)} %</h6>
                      </div>
                    </>
                  ))}
                </>
              }
            </div>
          </div>
          {/* <div style={{ height: "50px", backgroundColor: "#0097a7" }}>
            <div style={{ height: "50px" }} className="text-center">
              <h5 className="text-white">Poblaciones desde donde nos visitan</h5>
            </div>
          </div>
          {dataFuentes1 &&
            <Pie options={optionsFuentes} data={dataFuentes1} />
          } */}
        </div>
      </div>
    </div>
  );
};
